import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'notification-data',
  templateUrl: './notification-data.component.html',
  styleUrls: ['./notification-data.component.less']
})
export class NotificationDataComponent implements OnInit {
  @Input() notificationList: any[] = []; 
  @Output() handleCloseNotification: EventEmitter<string> = new EventEmitter<string>();
  @Output() handleGetList: EventEmitter<string> = new EventEmitter<string>();
  
  constructor(private message: NzMessageService,
    private translate: TranslateService,private router: Router,private notificationService:NotificationService) { }

  ngOnInit(): void {
  }
  markAsRead(isAll:boolean,id?:number): void{
    let params = {
      messageIdList:isAll?[]:[id]
    }
    this.notificationService.setRead(params).subscribe(()=>{
      this.message.create(
        'success',
        this.translate.instant('OPERATION_SUCCESS')
      );
      this.handleGetList.emit();
    })
  }
  checkUrl(path:any):void{
    window.open(path,'_blank');
  }
  
  goPage(path:any):void{
    const country = localStorage.getItem("country");
    //close modal
    this.handleCloseNotification.emit();
    this.router.navigateByUrl('', {skipLocationChange:true}).then(() => {
      this.router.navigate([`${country}/${path}`], {
      });
  });
  }

}
